import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { IGovernmentProjectPagedRequest } from '../../../../model/apm/government-project/request/government-project-paged-request';
import { IGovernmentProjectAddEditRequest } from '../../../../model/apm/government-project/request/government-project-add-edit-request';
import { IGovernmentProjectListResponse } from '../../../../model/apm/government-project/response/government-project-list-response';
import { IGovernmentProjectResponse } from '../../../../model/apm/government-project/response/government-project-response';

const defaultPath = 'GovernmentProject';

// Paginação 0-based; a API limita PageSize a 100
const list = async (params: IGovernmentProjectPagedRequest): Promise<Pagination<IGovernmentProjectListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: {
            Term: params.term || undefined,
            Type: params.type,
            Page: params.page,
            PageSize: params.pageSize,
        }
    }).then((response) => Object.assign(new Pagination<IGovernmentProjectListResponse>(), response.data));
};

const getById = async (id: number): Promise<IGovernmentProjectResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IGovernmentProjectAddEditRequest): Promise<IGovernmentProjectResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: params
    }).then((response) => response.data);
};

const edit = async (id: number, params: IGovernmentProjectAddEditRequest): Promise<IGovernmentProjectResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const GovernmentProjectAppService = { list, getById, add, edit, remove };
export default GovernmentProjectAppService;
